import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';

@Component({
  selector: 'ui-detail-row',
  imports: [],
  templateUrl: './ui-detail-row.component.html',
  styleUrl: './ui-detail-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiDetailRowComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly value: InputSignal<string | null> = input<string | null>(null);

  protected readonly hasValue: Signal<boolean> = computed((): boolean => !!this.value());
}
